import React, { useCallback, useEffect, useRef, useState } from 'react'

function useStateCallback(data) {
  const [state, setState] = useState(data)
  const cbRef = useRef(null)

  const setStateCallback = useCallback((state, cb) => {
    cbRef.current = cb
    setState(state)
  }, [])

  useEffect(() => {
    if (cbRef.current) {
      cbRef.current(state)
      cbRef.current = null
    }
  }, [state])

  return [state, setStateCallback]
}

export default useStateCallback
